import { FormControl, InputAdornment } from "@mui/material";
import InputTheme from "../input";
import { LangContext } from "../../../contexts/LangContext";
import { useContext } from "react";
import React from "react";
import CreateIcon from "@mui/icons-material/Create";

export default function InputDatabase({ errorText, ...props }) {
  const { lang } = useContext(LangContext);

  return (
    <FormControl sx={{ width: "100%", variant: "standard" }}>
      <InputTheme
     disabled
     id="standard-disabled"
      
        error={props.error}
        helperText={errorText ? "" : errorText}
        label="Database"
        variant="standard"
        type="text"
        {...props}
      />
      
    </FormControl>
  );
}
